import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

export default function useMetricDictionaryAccess() {
  const isFeatureFlagEnabled = usePostHogFeatureFlags(
    POSTHOG_FEATURES.METRIC_DICTIONARY,
  )

  return isFeatureFlagEnabled
}
